<template>
  <div>
    <v-list flat class="week-work-list">
      <v-list-item-group v-for="item in workStatusList" :key="item.ymd">
        <!-- 1. 내용 -->
        <v-list-item :ripple="false">
          <v-list-item-content>
            <v-list-item-subtitle class="mb-1">
              <span class="day">
                {{ item.ymdFormat }}
              </span>
            </v-list-item-subtitle>
            <v-list-item-title>
              <v-chip class="chip-desc blue" label>
                {{ $t(item.workTime) }}
              </v-chip>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content class="divider long">
            <v-list-item-subtitle class="mb-1"
              ><span class="date">{{ $t('출근') }}</span></v-list-item-subtitle
            >
            <v-list-item-title class="time">{{ item.inHm }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-subtitle class="mb-1"
              ><span class="date">{{ $t('퇴근') }}</span></v-list-item-subtitle
            >
            <v-list-item-title class="time">{{ item.outHm }}</v-list-item-title>
          </v-list-item-content>

          <!-- (23.12.21 추가) 근무시간명 -->
          <!-- 디자인 임시 - 요청필! -->
          <v-list-item-icon class="align-self-center">
            <v-chip-group class="chips-wrap ml-auto">
              <v-chip label style="background-color: #def6e5; color: #777e87">
                <v-icon size="14" color="#777e87" class="mr-1"
                  >mdi-clock-time-two-outline</v-icon
                >
                {{ $t(item.timeNm) }}
              </v-chip>
            </v-chip-group>
          </v-list-item-icon>
        </v-list-item>

        <!-- 2. 근태상태 칩 -->
        <v-list-item
          :ripple="false"
          class="chip-list"
          v-show="item.dayDiv != null || item.gntChipList != ''"
        >
          <v-chip-group class="chips-wrap">
            <v-chip label class="bcFFBEBE" v-if="item.dayDiv != null">
              {{ item.dayDiv }}
            </v-chip>
            <div v-for="chipItem in item.gntChipList" :key="chipItem.id">
              <v-chip label :class="`bc${chipItem.color}`">
                {{ chipItem.name }}
              </v-chip>
            </div>
          </v-chip-group>
        </v-list-item>

        <!-- 3. 구분선 -->
        <v-divider inset class="list-divider-line"></v-divider>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
// 근무현황 상세리스트 컴포넌트
import dayjs from 'dayjs';
import { getTime } from '@/utils/common/dateUtil';
import { getWorkStaWeekList } from '@/api/workStatus';
// import routerNames from '@/const/routerConstants';

export default {
  props: {
    // 조회기간파라미터
    searchTermParam: {
      type: Object,
    },
  },

  data: () => ({
    workStatusList: [], // 근무현황목록
  }),

  watch: {
    searchTermParam() {
      this.fetchWorkStaWeekList(this.searchTermParam); // 조회
    },
  },

  methods: {
    /* 개인근무현황 주단위조회 */
    async fetchWorkStaWeekList(param) {
      try {
        // 1. 파라미터 세팅 및 api 호출
        const response = await getWorkStaWeekList({
          searchSdate: param.sdate,
          searchEdate: param.edate,
        });
        const dataList = response.data.data;

        // 2. 초기화
        this.workStatusList = [];

        // 3. 결과값 세팅
        dataList.forEach(data => {
          // 근태값이 있을 경우 근태칩리스트 세팅
          let gntChipList = [];
          if (data.gntNmAppr != null) {
            let gntNmApprArr = data.gntNmAppr.split(',');

            for (var i = 0; i < gntNmApprArr.length; i++) {
              if (gntNmApprArr[i] !== '') {
                gntChipList.push({
                  id: i,
                  color: gntNmApprArr[i].split(';')[0],
                  name: gntNmApprArr[i].split(';')[1],
                });
              }
            }
          }

          this.workStatusList.push({
            ...data,
            gntChipList,
            inHm: data.inHm != null ? getTime(`${data.ymd}${data.inHm}`) : '-',
            outHm:
              data.outHm != null ? getTime(`${data.ymd}${data.outHm}`) : '-',
            workTime:
              data.workTime != null
                ? dayjs(`${data.ymd}${data.workTime}`).format('H시간m분')
                : '-시간',
          });
        });

        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
        return response;
      } catch (error) {
        console.log(error);
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
    /* 휴가 신청화면으로 이동 */
    // toApplicationMenu() {
    //   this.$router.push(routerNames.ApplicationMenu);
    // },
  },

  created() {
    if (this.searchTermParam != undefined) {
      this.fetchWorkStaWeekList(this.searchTermParam); // 조회
    }
  },
};
</script>

<style></style>
